import Hosts from '../../../../Hosts';

const object_type = 'intranet/quality'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/type/${companycode}/acompanhamento`

const base_endpoint = '/intranet_quality_acompanhamento'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    //view: `${base_endpoint}_view`,
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        name: [],
        description: [],
        tag: '',
        file: {
            editable: [],
            pdf: []
        },
        settings: {},
        responsable: {
            edit: {},
            aproval: {},
            remove: {}
        },
        responsable_entregas: {
            update: {}
        },
        responsable_devolucoes: {
            update: {}
        },
        historic: [],
        contacts: {},
        stage: '',
        type: 'acompanhamento',
        companycode: '',
        active: false,
        avaiable: false,
        stock: 0,
        validade: '',
        data_admissao: '',
        data_demissao: '',

        obra: '',
        cliente: '',
        data: '',
        esquema_tratamento_superficial: '',

        linha_template: {
            prep_superficie: '',
            primario: {
                tipo: '',
                espessura_seca: ''
            },
            acabamento: {
                tipo: '',
                espessura_seca: ''
            },
            ral: ''
        },
        linhas: [],
        tabela_pintura: [],
        edition_archive_entregas: [],
        edition_archive_devolucoes: [],
    }
}

export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route,
}
